import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { RankedContributor } from "@/lib/types";

import { ContributorCard } from "./ContributorCard";

interface ContributorListProps {
  contributors: RankedContributor[];
  highlightedContributor: string | null;
  onHoverContributor: (login: string | null) => void;
}

export function ContributorList({ contributors, highlightedContributor, onHoverContributor }: ContributorListProps) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between gap-4">
        <CardTitle>Engineers</CardTitle>
        <p className="text-sm text-muted-foreground">{contributors.length}</p>
      </CardHeader>
      <CardContent className="space-y-4">
        {contributors.length ? (
          contributors.map(contributor => (
            <ContributorCard
              key={contributor.login}
              contributor={contributor}
              highlighted={highlightedContributor === contributor.login}
              onHover={onHoverContributor}
            />
          ))
        ) : (
          <p className="text-sm text-muted-foreground">No contributors returned.</p>
        )}
      </CardContent>
    </Card>
  );
}
